<template>
  <section class="small-basket-control">
    <div class="small-basket-control__icon" @click="handlerOpenBasket">
      <svg><use xlink:href="#svg-basket"></use></svg>
      <span v-if="items" class="small-basket-control__count">{{ items.length }}</span>
    </div>
    <DefEmpty v-if="isOpenMessage && !items?.length" @close="isOpenMessage = false">
      {{ messages.noItems }}
    </DefEmpty>
  </section>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import DefEmpty from '@components/Def/DefEmpty/DefEmpty.vue';
import Basket from '@components/Basket/Basket.vue';
import useModalAside from '@use/useModalAside/useModalAside';
import useBasketState from '@use/useBasketState';

export default {
  name: 'SmallBasket',
  components: {
    DefEmpty,
  },
  data() {
    return {
      modalAside: useModalAside(),
      basketState: useBasketState(),
      isOpenMessage: false,
    };
  },
  computed: {
    ...mapState({
      messages: ({ basket }) => basket.data.messages,
      items: ({ basket }) => basket.data.items,
    }),
  },

  methods: {
    handlerOpenBasket() {
      if (this.items?.length) {
        this.basketState.open();
      } else {
        this.isOpenMessage = true;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.small-basket-control {
  &__icon {
    display: flex;
    align-items: center;
    cursor: pointer;
    position: relative;
    svg {
      display: block;
      width: 24px;
      height: 24px;
      fill: var(--background-black);
      transition: 0.2s linear fill, 0.2s linear transform;
    }
    &:hover {
      svg {
        fill: var(--color-link-hover-dark);
        transform: scale(1.1);
      }
      .small-basket-control__count {
        //color: var(--color-link-hover-dark);
      }
    }
  }
  &__count {
    font-weight: 600;
    font-size: rem(12);

    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    width: 16px;
    height: 16px;
    background-color: var(--color-main);
    border-radius: 50%;
    position: absolute;
    top: -8px;
    right: -8px;
    color: #fff;
  }
}
</style>
